import React, { Fragment } from 'react';
import { useHistory } from 'react-router-dom';
const Notification = props => {
    const history = useHistory();

    const goToOnayEkrani = () => {
        history.push("/onay-ekrani");
    };
    // const [notifications, setNotifications] = useState([]);

    // const fetchNotifications = async () => {
    //     try {
    //         const response = await Axios.post('http://localhost:8086/notfication'); // Mockoon'dan aldığınız GET API
    //         setNotifications(response.data.Result);
    //     } catch (error) {
    //         console.error('Error fetching notifications:', error);
    //     }
    // };

    // useEffect(() => {
    //     fetchNotifications();
    //     const interval = setInterval(fetchNotifications, 5000); // 5 saniyede bir kontrol

    //     return () => clearInterval(interval);
    // }, []);
    let notifications = [

    ]

    return (
        <Fragment>
            <div>
                <ul className="notification-dropdown onhover-show-div p-0">
                    <li>Notification <span className="badge badge-pill badge-primary pull-right">
                        {notifications.length}
                    </span></li>
                    {
                        notifications.map((notification, i) =>
                            <li key={i}
                                style={{
                                    backgroundColor: notification.isRead ? "#f5f5f5" : "#fff",
                                    cursor: "pointer"

                                }}
                                onClick={goToOnayEkrani}
                            >
                                <div className="media">
                                    <div className="media-body">
                                        <h6 className="mt-0"><span><i className={notification.icon}></i></span>{notification.title}</h6>
                                        <p className="mb-0">{notification.datail}</p>
                                    </div>
                                </div>
                            </li>
                        )
                    }
                    {/* <li>
                        <div className="media">
                            <div className="media-body">
                                <h6 className="mt-0"><span><ShoppingBag /></span>Your order ready for Ship..!</h6>
                                <p className="mb-0">Lorem ipsum dolor sit amet, consectetuer.</p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="media">
                            <div className="media-body">
                                <h6 className="mt-0 txt-success"><span><Download className="font-success" /></span>Download Complete</h6>
                                <p className="mb-0">Lorem ipsum dolor sit amet, consectetuer.</p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="media">
                            <div className="media-body">
                                <h6 className="mt-0 txt-danger"><span><AlertCircle className="font-danger" /></span>250 MB trash files</h6>
                                <p className="mb-0">Lorem ipsum dolor sit amet, consectetuer.</p>
                            </div>
                        </div>
                    </li> */}
                    <li className="txt-dark"><a href="#javascript">All</a> notification</li>
                </ul>
            </div>
        </Fragment>
    );
};

export default Notification;
